import SiteLayout from '@/components/feature/SiteLayout';
import useSeo from '@/hooks/useSeo';
import { articles, faqs } from '@/mocks/siteData';
import Hero from '@/pages/home/components/Hero';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import LatestFeed from '@/pages/home/components/LatestFeed';
import Testimonials from '@/pages/home/components/Testimonials';
import FaqSection from '@/pages/home/components/FaqSection';
import SubmitCta from '@/pages/home/components/SubmitCta';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '爆料吃瓜',
    url: 'https://rudolf1922.cn/',
    description: '爆料吃瓜现场直击，全程围观最新进展的娱乐资讯门户。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://rudolf1922.cn/category/all?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爆料吃瓜',
    url: 'https://rudolf1922.cn/',
    email: 'baoliao@chigua-site.com',
    description: '专注娱乐爆料信息整理的内容网站，人物统一使用代称，坚持核实后再发布。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '最新爆料进展',
    itemListElement: articles.slice(0, 6).map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url: `https://rudolf1922.cn/article/${item.id}`,
      name: item.title,
    })),
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: { '@type': 'Answer', text: faq.a },
    })),
  },
];

export default function Home() {
  useSeo({
    title: '爆料吃瓜 - 爆料吃瓜现场直击，全程围观爆料吃瓜最新进展',
    description:
      '爆料吃瓜官网，实时更新爆料吃瓜现场一手消息，围观明星网红翻车实况，全程直击爆料吃瓜最新进展，吃瓜群众速来围观，看热闹不迷路。',
    keywords: '爆料吃瓜,爆料吃瓜现场,爆料吃瓜最新进展,爆料吃瓜围观,明星动态,网红圈',
    path: '/',
    jsonLd: homeJsonLd,
  });

  return (
    <SiteLayout>
      <Hero />
      <CategoryGrid />
      <LatestFeed />
      <Testimonials />
      <FaqSection />
      <SubmitCta />
    </SiteLayout>
  );
}